//INITIAL FLOW
import * as types from "./actionTypes";

export const setQuotes = (quotes) => ({
  type: types.SET_QUOTES,
  payload: {quotes}
});

export const updateQuote = (quote, quoteIndex) => ({
  type: types.UPDATE_QUOTE,
  payload: {quote, quoteIndex}
});

export const setActiveQuoteIndex = (activeQuoteIndex) => ({
  type: types.SET_ACTIVE_QUOTE_INDEX,
  payload: {activeQuoteIndex}
});
